import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./styles.css";
import { useSelector } from "react-redux";

export default function CertifModalForm({ onClose, refresh, certifToUpdate, secteur }) {
    const [nomCertif, setNomCertif] = useState("");
    const [logoCertif, setLogoCertif] = useState(null);
    const [previewIcon, setPreviewIcon] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const { token } = useSelector((state) => state.auth);

    useEffect(() => {
        if (certifToUpdate) {
            setNomCertif(certifToUpdate.nomCertif || "");
            setPreviewIcon(
                certifToUpdate.logo
                    ? `${apiUrl}/api/files/?categorie=certifs&file=${certifToUpdate.logo}`
                    : null
            );
        } else {
            setNomCertif("");
            setPreviewIcon(null);
        }
    }, [certifToUpdate, apiUrl]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("nomCertif", nomCertif);

        if (logoCertif) {
            formData.append("logoCertif", logoCertif);
        }
        if(secteur){
            formData.append("idSecteur",secteur.idSecteur);
        }

        const isUpdate = !!certifToUpdate;
        if (isUpdate) {
            formData.append("_method", "PUT"); // 🔁 même principe que pour secteur
        }

        try {
            const url = isUpdate
                ? `${apiUrl}/api/certifs/${certifToUpdate.idMetier}`
                : `${apiUrl}/api/certifs`;

            const response = await fetch(url, {
                method: "POST", // ⚠️ toujours POST
                body: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                    // pas de "Content-Type" → laissé à fetch
                }
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || "Erreur sauvegarde certif");

            alert(data.message || (isUpdate ? "Certif mis à jour" : "Certif créé"));
            refresh();
            onClose();
        } catch (err) {
            console.error(err);
            alert(err.message);
        }
    };


    return (
        <div className="modal-overlay">
            <div className="modal-certif">
                <button className="modal-close" onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                <h3>{certifToUpdate ? "Modifier la certification" : "Ajouter une certification"}</h3>
                <form onSubmit={handleSubmit} className="form">
                    <div className="form-group">
                        <label>Nom de la certification</label>
                        <input
                            type="text"
                            value={nomCertif}
                            onChange={(e) => setNomCertif(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Logo de la certification</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                                setLogoCertif(e.target.files[0]);
                                setPreviewIcon(URL.createObjectURL(e.target.files[0]));
                            }}
                        />
                        {previewIcon && (
                            <div className="preview">
                                <img src={previewIcon} alt="Aperçu" className="preview-icon" />
                            </div>
                        )}
                    </div>

                    <button type="submit" className="btn-submit">
                        {certifToUpdate ? "Mettre à jour" : "Créer"}
                    </button>
                </form>
            </div>
        </div>
    );
}
